import { render } from "./VolumeOffIcon.vue?vue&type=template&id=8b52e1c0"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__